import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import DataTable from '../../components/ui/data-table';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import { assignmentService } from '../../services/assignmentService';

const AssignmentGrade = () => {
  const { id } = useParams();
  const [submissions, setSubmissions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await assignmentService.getSubmissions(id);
      setSubmissions(res.data.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load submissions');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { fetchData(); }, [id]);

  const grade = async (submissionId) => {
    const score = prompt('Enter score (0-100)');
    if (score == null) return;
    try {
      await assignmentService.gradeSubmission(id, submissionId, { score: Number(score) });
      await fetchData();
    } catch (e) {
      alert(e.response?.data?.message || 'Failed to grade');
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="p-6 text-sm text-red-600">{String(error)}</div>;

  const columns = [
    { id: 'student', header: 'Student', accessorKey: 'studentName' },
    { id: 'submittedAt', header: 'Submitted At', accessorKey: 'submittedAt' },
    { id: 'score', header: 'Score', accessorKey: 'score' },
    { id: 'actions', header: 'Actions', cell: ({ row }) => (
      <Button size="sm" onClick={() => grade(row.id)}>Grade</Button>
    ) }
  ];

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Submissions</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <DataTable data={submissions} columns={columns} />
        </CardContent>
      </Card>
    </div>
  );
};

export default AssignmentGrade;


